(function() {
  var PHONE_KEY = 'gg_pickup_phone';

  function getStoredPhone() {
    try { return sessionStorage.getItem(PHONE_KEY) || ''; } catch(e) { return ''; }
  }

  function setStoredPhone(val) {
    try { sessionStorage.setItem(PHONE_KEY, val); } catch(e) {} 
  }

  function isValidPhone(val) {
    return /^[\d\s\+\-\(\)]{7,20}$/.test(val.trim());
  }

  function updateCartNote(phone, cb) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: 'Contact Phone: ' + phone.trim() })
    }).then(function() { if (cb) cb(); }).catch(function() { if (cb) cb(); });
  }

  function buildField(wrapperId, inputId) {
    var wrapper = document.createElement('div');
    wrapper.id = wrapperId;
    wrapper.style.cssText = 'margin: 12px 0; padding: 14px 16px; background: #fff8e7; border: 1.5px solid #e0a800; border-radius: 6px;';

    var label = document.createElement('label');
    label.setAttribute('for', inputId);
    label.style.cssText = 'display:block; font-size:13px; font-weight:600; margin-bottom:6px; color:#333;';
    label.textContent = '📞 Contact phone number (required for collection)';

    var input = document.createElement('input');
    input.type = 'tel';
    input.id = inputId;
    input.placeholder = 'e.g. 07911 123456';
    input.value = getStoredPhone();
    input.style.cssText = 'width:100%; box-sizing:border-box; padding:8px 10px; border:1px solid #ccc; border-radius:4px; font-size:14px; margin-bottom:8px;';

    var error = document.createElement('p');
    error.style.cssText = 'color:#c0392b; font-size:12px; margin:0 0 6px; display:none;';
    error.textContent = 'Please enter a valid phone number before checking out.';

    var saved = document.createElement('p');
    saved.style.cssText = 'color:#27ae60; font-size:12px; margin:0; display:none;';
    saved.textContent = '✓ Phone number saved';

    input.addEventListener('input', function() {
      setStoredPhone(input.value);
      error.style.display = 'none';
      saved.style.display = 'none';
    });

    input.addEventListener('blur', function() {
      if (input.value.trim() && isValidPhone(input.value)) {
        updateCartNote(input.value, function() {
          saved.style.display = 'block';
        });
      }
    });

    wrapper.appendChild(label);
    wrapper.appendChild(input);
    wrapper.appendChild(error);
    wrapper.appendChild(saved);

    return { wrapper: wrapper, input: input, error: error };
  }

  function interceptCheckout(btnId, fieldInputId, fieldErrorEl) {
    var btn = document.getElementById(btnId);
    if (!btn) return;
    btn.addEventListener('click', function(e) {
      var input = document.getElementById(fieldInputId);
      if (!input) return;
      var val = input.value.trim();
      if (!isValidPhone(val)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        fieldErrorEl.style.display = 'block';
        input.focus();
        input.style.borderColor = '#c0392b';
        return false;
      }
      updateCartNote(val);
    }, true);
  }

  function initCartPage() {
    if (document.getElementById('gg-phone-field')) return;
    var checkoutBtn = document.getElementById('checkout');
    if (!checkoutBtn) return;

    var field = buildField('gg-phone-field', 'gg-phone-input');
    var ctas = checkoutBtn.closest('.cart__ctas');
    if (ctas) {
      ctas.parentNode.insertBefore(field.wrapper, ctas);
    } else {
      checkoutBtn.parentNode.insertBefore(field.wrapper, checkoutBtn);
    }
    interceptCheckout('checkout', 'gg-phone-input', field.error);
  }

  function initCartDrawer() {
    if (document.getElementById('gg-phone-field-drawer')) return;
    var drawerCheckout = document.getElementById('CartDrawer-Checkout');
    if (!drawerCheckout) return;

    var field = buildField('gg-phone-field-drawer', 'gg-phone-input-drawer');
    var ctas = drawerCheckout.closest('.cart__ctas');
    if (ctas) {
      ctas.parentNode.insertBefore(field.wrapper, ctas);
    } else {
      drawerCheckout.parentNode.insertBefore(field.wrapper, drawerCheckout);
    }
    interceptCheckout('CartDrawer-Checkout', 'gg-phone-input-drawer', field.error);
  }

  function init() {
    initCartPage();
    initCartDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart-drawer:open', function() {
    setTimeout(initCartDrawer, 150);
  });

  var observer = new MutationObserver(function() {
    initCartDrawer();
  });

  document.addEventListener('DOMContentLoaded', function() {
    var el = document.getElementById('CartDrawer');
    if (el) observer.observe(el, { childList: true, subtree: true });
  });

})();